import React, { type FC } from 'react'
import { useIntl } from 'react-intl'
import { ShareButton } from '../ui/ShareButton'

export const ReferralShareButton: FC<{
  url: string
  className?: string
  disabled?: boolean
  onSuccess?: () => void
  onError?: (error: Error) => void
}> = ({ className, disabled, onSuccess, onError, url }) => {
  const { formatMessage } = useIntl()

  const shareText = formatMessage({
    id: 'bonus.shareText',
    defaultMessage: '🎁 Присоединяйся к VoteBox и получи бонусы!',
  })

  return (
    <ShareButton
      url={url}
      text={shareText}
      className={className}
      disabled={disabled}
      onSuccess={onSuccess}
      onError={onError}
    />
  )
}
